import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { MailerModule } from '../__common__/mailer/mailer.module';
import { DlModuleAdapter } from './dl-module.adapter';
import { DlModuleController } from './dl-module.controller';
import { DlModuleService } from './dl-module.service';
import { DLMasterEntity } from './entities/dl-master.entity';
import { ProductionPlanEntity } from './entities/dl-production-plan.entity';
import { DLWhDateChangeLogEntity } from './entities/dl-wh-date-change-log.entity';
import { PARequestChildEntity } from './entities/pa-request-child-entity';
import { PARequestListEntity } from './entities/pa-request-list-entity';
import { DLMasterRepository } from './repositories/dl-master.repository';
import { ProductionPlanRepository } from './repositories/dl-production-plan.repository';
import { PARequestChildRepo } from './repositories/pa-child-repo';
import { PARequestListRepository } from './repositories/pa-request-list-repo';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      DLMasterEntity,
      ProductionPlanEntity,
      PARequestListEntity,
      PARequestChildEntity,
      DLWhDateChangeLogEntity
    ]),
    MailerModule
  ],
  controllers: [DlModuleController],
  providers: [DlModuleService, DLMasterRepository, ProductionPlanRepository, ApplicationExceptionHandler, DlModuleAdapter, PARequestListRepository, PARequestChildRepo]
})
export class DlModuleModule { }
